export const LOADING_GRAPH = "LOADING_GRAPH";
export const GRAPH_LOADED = "GRAPH_LOADED";
export const SET_AXIS_VALUES = "SET_AXIS_VALUES";

export function processFiles() {
	return (dispatch, getState) => {
		dispatch(startLoading());

		return new Promise((resolve, reject) => {
			let state = getState();
			let files = ["xFile", "yFile", "zFile"];
			let axis = {};

			for (let i = 0; i < files.length; i++) {
				let f = files[i];
				let file = state.fileContents[f];
				let data = file.fileContent;

				if (f.headersExist) {
					data = data.slice(1);
				}

				let values = unpack(data, file.selectedColumns);
				let max = Math.max(values);
				let min = Math.min(values);
				
				axis[f] = {
					values,
					max,
					min,
					label: file.axisLabel,
				};
			}

			dispatch(setAxis(axis));
			resolve();
		}).then(() => {
			dispatch(endLoading());
		}).catch((err) => {
			console.log(err);
		});
	};
}

function unpack(rows, index) {
	return rows.map(function(row) 
	{ return row[index]; });
}

export function setAxis(axis) {
	return {
		type: SET_AXIS_VALUES,
		axis
	};
}

export function startLoading() {
	return {
		type: LOADING_GRAPH,
	};
}

export function endLoading() {
	return {
		type: GRAPH_LOADED,
	};
}


// WEBPACK FOOTER //
// ./src/redux/graph-actions.js